<script setup>
defineProps({
  steps: {
    type: Array,
    required: true,
    // Array of step titles
  },
  currentStep: {
    type: Number,
    default: 0,
  },
})
</script>

<template>
  <div class="form-stepper">
    <div class="stepper-track">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step"
        :class="{
          completed: index < currentStep,
          active: index === currentStep,
          pending: index > currentStep,
        }"
      >
        <div class="step-indicator">
          <span v-if="index < currentStep" class="material-symbols-rounded check-icon">check</span>
          <span v-else class="step-number">{{ index + 1 }}</span>
        </div>
        <span class="step-title">{{ step }}</span>
        <div v-if="index < steps.length - 1" class="step-connector"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-stepper {
  width: 100%;
  padding: var(--spacing-md) 0;
}

.stepper-track {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
}

.step-indicator {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  transition: all var(--transition-base);
  z-index: 1;
}

.step.pending .step-indicator {
  background: var(--bg-secondary);
  color: var(--text-muted);
  border: 2px solid var(--border-color);
}

.step.active .step-indicator {
  background: var(--color-primary);
  color: var(--color-white);
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.2);
}

.step.completed .step-indicator {
  background: var(--color-success);
  color: var(--color-white);
}

.check-icon {
  font-size: 18px;
}

.step-title {
  margin-top: var(--spacing-xs);
  font-size: var(--font-size-xs);
  color: var(--text-muted);
  text-align: center;
  max-width: 80px;
  line-height: 1.3;
  transition: color var(--transition-fast);
}

.step.active .step-title {
  color: var(--color-primary);
  font-weight: var(--font-weight-medium);
}

.step.completed .step-title {
  color: var(--color-success);
}

.step-connector {
  position: absolute;
  top: 18px;
  right: calc(50% + 24px);
  width: calc(100% - 48px);
  height: 2px;
  background: var(--border-color);
  transition: background var(--transition-base);
}

.step.completed .step-connector {
  background: var(--color-success);
}

/* Mobile responsive */
@media (max-width: 600px) {
  .step-title {
    display: none;
  }

  .step-indicator {
    width: 32px;
    height: 32px;
    font-size: var(--font-size-xs);
  }

  .step-connector {
    top: 16px;
    right: calc(50% + 20px);
    width: calc(100% - 40px);
  }
}
</style>
